import { render, staticRenderFns } from "./ShippingBadges.vue?vue&type=template&id=727151ce&scoped=true&"
import script from "./ShippingBadges.vue?vue&type=script&lang=js&"
export * from "./ShippingBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727151ce",
  null
  
)

export default component.exports